import {Transaction, Product} from 'progressive-web-sdk/dist/analytics/data-objects/'

const extractPrice = (string = '') => {
    const index = string.indexOf('$')
    const dollarValue = string.slice(index !== -1 ? index : 0)

    return parseFloat(dollarValue.replace('$', ''))
}

const extractQty = (string) => string.match(/\d+/)[0]

const checkoutConfirmation = {
    isActivePage: () => /\/checkout\/confirmation/.test(window.location.pathname),

    getPurchaseDetails: () => {
        const $ = window.$

        const transaction = {
            [Transaction.ID]: $('.orderid span').text(),
            [Transaction.REVENUE]: extractPrice($('[data-elemname="total_text"]').text()),
            [Transaction.TAX]: extractPrice($('[data-elemname="tax_text"]').text()),
            [Transaction.SHIPPING]: extractPrice($('[data-elemname="shipping_text"]').text())
        }

        const $productRows = $('.itemTable .row-fluid').not('.tableHead')
        const products = $productRows.map((_, row) => {
            const $row = $(row)
            return {
                [Product.ID]: $row.find('[data-elemname^="sku_text"]').text(),
                [Product.NAME]: $row.find('[data-elemname^="brand_part_text"]').text()
                    .trim(),
                [Product.PRICE]: extractPrice($row.find('[data-elemname^="price_text"]').text()),
                [Product.QUANTITY]: extractQty($row.find('[data-elemname^="qty_text"]').text())
            }
        }).get()

        return {
            transaction,
            products
        }
    }
}

export default checkoutConfirmation



// WEBPACK FOOTER //
// ./non-pwa/pages/checkout-confirmation.js